export const CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR = 'CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR';
export type CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR = typeof CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR;

export interface ChangeMobileCampaignServiceEditor {
    type: CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR;
    editorId: string;
    isMobile: boolean;
}

export function changeMobileCampaignServiceEditorAction(
    editorId: string,
    isMobile: boolean
): ChangeMobileCampaignServiceEditor {
    return {
        type: CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR,
        editorId,
        isMobile
    };
}
